var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tw-font-semibold tw-w-full tw-p-3 tw-rounded tw-text-[#64748B] tw-bg-white hover:tw-bg-gray-100"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }